import { SET_PROFILEDATA } from '@src/shared/constants/fetchConstants';
import { createAction } from 'typesafe-actions';
export const setUserProfileAC = createAction(SET_PROFILEDATA, action => (data) => action(data));
